import {Component} from 'react';
import React from 'react';
import TopBar from "./TopBar";

class Menu extends Component {
    constructor(props) {
        /*
            Props:
             - pageList []
                - id
                - picture
                - title
             - pageSelected
        */
        super(props);
        this.state = {};
        if(props.pageList[0]!=null) {
            this.state.selected = props.pageList[0].id;
        }
    }
    
    render() {

        const lst = [];

        for(let page of this.props.pageList) {
            lst.push((
                <li key={page.id} className={"sidebar-item"+(this.state.selected===page.id ? " selected" : "")}><a onClick={() => {
                    this.setState({selected: page.id});
                    this.props.pageSelected(page.id);
                }}
                                          className="sidebar-link waves-effect waves-dark sidebar-link"
                                          href="#" aria-expanded="false">{page.picture}<span className="hide-menu">{page.title}</span></a>
                </li>
            ));
        }

        return (
            <div>
                <aside className="left-sidebar" data-sidebarbg="skin5">
                    <div className="scroll-sidebar">
                        <nav className="sidebar-nav">
                            <ul id="sidebarnav" className="p-t-30">
                                {lst}
                            </ul>
                        </nav>
                    </div>
                </aside>
            </div>
        );
    }
}

export default Menu;